import SuperFetch from '../../../superFetch.js';

class NoticeStoreApi {
  /**
   *  [상점 공지사항 리스트] 상점 공지사항 리스트 가져오기
   */
  getNoticeStoreList = (data) => SuperFetch.post('/notice/store/list', data);

  /**
   *  [상점 공지사항 리스트] 상점 공지사항 리스트 엑셀 다운로드 하기
   */
  getNoticeStoreExcelDownload = (data) => SuperFetch.post('/notice/store/list/excel/download', data);

  /**
   *  [상점 공지사항 리스트] 선택된 상점 공지사항 삭제하기
   */
  deleteNoticeStore = (data) => SuperFetch.post('/notice/store/list/delete', data);

  /**
   *  [상점 공지사항 등록] 상점 공지사항 등록시 필요한 정보 가져오기
   */
  prepareAddNoticeStore = (data) => SuperFetch.post('/notice/store/preparation', data);

  /**
   *  [상점 공지사항 등록] 상점 공지사항 등록하기
   */
  addNoticeStore = (data) => SuperFetch.post('/notice/store/insert', data);

  /**
   *  [상점 공지사항 편집] 상점 공지사항 요청하기
   */
  getNoticeStore = (data) => SuperFetch.post('/notice/store/detail', data);

  /**
   *  [상점 공지사항 편집] 상점 공지사항 편집하기
   */
  editNoticeStore = (data) => SuperFetch.post('/notice/store/edit', data);
}

export default new NoticeStoreApi();
